import { css } from "@linaria/core";
import { styled } from "@linaria/react";
import { isMobile } from "../../../@css-style";

export const ElFaqs = styled.section`
  width: 100%;
  display: flex;
  /* padding: 10px; */
  position: relative;
  justify-content: space-between;
  font-family: "Plus Jakarta Sans", sans-serif;
  font-weight: 100;
  font-style: normal;
  padding: 5em 0;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: top;
  ${isMobile} {
    padding: 2em 0;
  }
  * {
    font-family: "Plus Jakarta Sans", sans-serif;
  }
`;

export const ElFaqsContent = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
  padding: 10px;
  align-items: center;
  justify-content: center;
`;

export const ElColumn = styled.div<{ "data-color"?: string }>`
  max-width: 100%;
  width: 100%;
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  justify-content: end;
  gap: 20px;
`;

export const ElHeaderTitle = styled.h2`
  /* font-size: 17px; */
  width: 100%;
  text-align: left;
  font-size: 36px;
  font-weight: 500;
  color: #fff;
  color: var(--theme-main-flat-dark-color);
`;

export const elGapFaqs = css`
  gap: 20px;
`;
